// Values mirror the SQL CHECK constraints in the `partner_*` tables.

export const PARTNER_ACCOUNT_STATUSES = {
  ACTIVE: "active",
  SUSPENDED: "suspended",
} as const

export const PARTNER_BALANCE_OPERATION_TYPES = {
  COMMISSION: "commission",
  TRANSFER_TO_WALLET: "transfer_to_wallet",
  PAYOUT_HOLD: "payout_hold",
  PAYOUT_REVERSAL: "payout_reversal",
  MANUAL_ADJUSTMENT: "manual_adjustment",
} as const

export const PARTNER_PAYOUT_STATUSES = {
  PENDING: "pending",
  COMPLETED: "completed",
  REJECTED: "rejected",
} as const

/** Skip reasons recorded per payment — the admin-state ones; facts of the payment are never recorded. */
export const PARTNER_COMMISSION_SKIP_REASONS = {
  PROGRAM_OFF: "program_off",
  SUSPENDED: "suspended",
  ZERO_PERCENT: "zero_percent",
} as const

export const REFERRAL_SOURCES = {
  LINK: "link",
  PROMO: "promo",
  /** Reserved: manual attach. */
  ADMIN: "admin",
} as const

/** Idempotency namespaces for the partner balance ledger. */
export const PARTNER_REFERENCE_TYPES = {
  PAYOUT_REQUEST: "payout_request",
  PAYOUT_REVERSAL: "payout_reversal",
  MANUAL_ADJUSTMENT: "manual_adjustment",
} as const

export const PARTNER_SETTING_KEYS = {
  DEFAULT_COMMISSION_PERCENT: "partner_default_commission_percent",
  MIN_PAYOUT_MICROUSD: "partner_min_payout_microusd",
  PROGRAM_ENABLED: "partner_program_enabled",
  WALLET_TRANSFER_ENABLED: "partner_wallet_transfer_enabled",
  CASH_PAYOUT_ENABLED: "partner_cash_payout_enabled",
  CASH_PAYOUT_FEE_PERCENT: "partner_cash_payout_fee_percent",
} as const

// Must match the migration seeds.
export const PARTNER_DEFAULT_COMMISSION_PERCENT = 10
export const PARTNER_DEFAULT_MIN_PAYOUT_MICROUSD = 50_000_000
export const PARTNER_DEFAULT_PROGRAM_ENABLED = false
export const PARTNER_DEFAULT_WALLET_TRANSFER_ENABLED = true
export const PARTNER_DEFAULT_CASH_PAYOUT_ENABLED = false
export const PARTNER_DEFAULT_CASH_PAYOUT_FEE_PERCENT = 0

export const PARTNER_REF_COOKIE = "partner_ref"
export const PARTNER_REF_COOKIE_MAX_AGE_SECONDS = 90 * 24 * 60 * 60
export const MAX_REFERRAL_CODE_LENGTH = 64
/** Result code of a signup that refuses a typed code up front (the Shopify claim). */
export const REFERRAL_CODE_INVALID = "referral_code_invalid"
